import { Stack } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { CrudFilters } from '@refinedev/core';
import { DeleteButton, EditButton, List, ShowButton, useDataGrid } from '@refinedev/mui';

import { VisibleInCell } from '../../components';
import { ThreatInformedDefense } from '../../types';

const ThreatInformedDefenseList = () => {
  const { dataGridProps, search } = useDataGrid<ThreatInformedDefense>({
    onSearch: search => {
      const filters: CrudFilters = [];

      filters.push({
        field: 'search',
        value: search,
        operator: 'eq'
      });

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'search',
          value: '',
          operator: 'eq'
        }
      ]
    }
  });

  const columns: GridColDef<ThreatInformedDefense>[] = [
    { field: 'title', headerName: 'Name', flex: 1 },
    { field: 'description', headerName: 'Description', flex: 1 },
    { field: 'highlight', headerName: 'Highlight', renderCell: ({ row }) => (row.highlight ? 'Yes' : 'No'), flex: 1 },
    { field: 'active', headerName: 'Active', renderCell: ({ row }) => (row.active ? 'Yes' : 'No'), flex: 1 },
    {
      field: '_visible_in',
      headerName: 'Visible In',
      renderCell: ({ row }) => <VisibleInCell {...row} />,
      sortable: false,
      flex: 1
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: params => (
        <Stack direction="row" spacing={1}>
          <ShowButton recordItemId={params.row.id} hideText />
          <EditButton recordItemId={params.row.id} hideText />
          <DeleteButton
            recordItemId={params.row.id}
            hideText
            confirmTitle={'Do you want to delete Threat Informed Defense item?'}
          />
        </Stack>
      ),
      sortable: false,
      flex: 1,
      maxWidth: 128
    }
  ];

  return (
    <List canCreate>
      <DataGridPro
        {...dataGridProps}
        filterModel={undefined}
        columns={columns}
        showToolbar
        pagination
        onFilterModelChange={({ quickFilterValues }) => {
          search(quickFilterValues?.join(' ') || '');
        }}
      />
    </List>
  );
};

export default ThreatInformedDefenseList;
